import React from "react";
import { motion } from "framer-motion";
import "../../assets/fonts/fonts.css";

export default function InfoBox({ title, body }) {
  return (
    <div className="max-w-4xl flex flex-col bg-black bg-opacity-45 p-4 md:p-8 m-[2vh] md:m-[5vh] rounded-xl shadow-lg text-white">
      <motion.h2
        className="m-auto md:m-0 text-2xl md:text-4xl nsans-7-sc-bo"
        initial={{ opacity: 0, scale: 0.8 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{
          delay: 0.2,
          duration: 1.2,
          type: "spring",
          stiffness: 30,
        }}
      >
        {title}
      </motion.h2>
      <motion.div
        className="max-w-3xl m-4 p-6 md:mx-8 md:p-6 bg-gradient-to-r from-slate-700 to-slate-800 rounded-xl shadow-lg text-white"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        whileHover={{ scale: 1.05 }}
        transition={{ type: "spring", stiffness: 60 }}
      >
        <motion.p
          className="text-base md:text-xl leading-relaxed nsans-7-sc-li"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4, duration: 1.2 }}
        >
          {body}
        </motion.p>
      </motion.div>
    </div>
  );
}
